import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'

const ToxicologyTestResults = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem right-padding6rem p-top-bottom2rem'>
            <Row className=''>
                <Col md='12' lg='7' className=''>
                    <div className=''>
                        <div className=''>
                            <text className='fs-ss-30-2 text-montserrat fw-700 text-ss-primary '>
                                Normal Test Results
                            </text>
                            <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </div>

                        <div className='pt-2'>
                            <text className='text-montserrat fw-600 text-ss-black fs-ss-16'>
                                Normal value ranges for prescription and over-the-counter medications may vary slightly from laboratory to laboratory. Discuss the significance of your specific test results with your provider.
                            </text>
                        </div>

                        <div className='mt-4'>
                            <ul className='text-montserrat fw-600 text-ss-black fs-ss-16'>
                                <li className=''>
                                    A negative value typically indicates that alcohol, unapproved prescription medications, and illegal drugs have not been identified.
                                </li>
                                <li className=''>
                                    A blood toxicology screen can decide the medication’s presence and level (measure) in your body.
                                </li>
                                <li className=''>
                                    Positive (a substance was found) or negative (no significance was found) results from urine samples are frequently reported.
                                </li>
                            </ul>
                        </div>

                        <div className='flex-center1 '>
                            <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                <Link to='/toxicology-test-appointment' className='text-montserrat text-white fw-600 fs-ss-18' style={{ padding:'12px 14px', textDecoration:'none'}}>
                                    Book Appointment
                                </Link>
                            </Button>
                        </div>
                    </div>
                </Col>

                <Col md='12' lg='5' className='pt-md-0 pt-4 '>
                    <div className='flex-center pt-4' >
                        <img className='img-w24' src='https://unitedlabcare.com/wp-content/uploads/2023/05/Toxicology-Testing-img1-v1.png' alt='Normal Test Result' />
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default ToxicologyTestResults